import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import { utils, read } from 'xlsx';
import { createKpiTableApi, getKpiTableApi, getPdfApi, getCsvApi, updateCsvApi, deletePdfApi } from '@/api';

import clonedeep from 'lodash.clonedeep';
import { mapState } from 'vuex';
var monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var pageList = {
  mppt: 'mppt',
  pv: 'pv',
  pdf: 'pdf',
  kpi: 'kpi'
};
var defaultKpiSetting = [{
  year: '2021-預設值請修改',
  PR: [80, 82, 91, 80, 82, 91, 80, 82, 91, 80, 82, 91],
  properRate: Array(12).fill(98),
  peakWatt: [3000, 2500, 1000, 3000, 2500, 1000, 3000, 2500, 1000, 3000, 2500, 1000],
  guaranteePr: Array(12).fill(0),
  guaranteePower: Array(12).fill(0),
  acpGoalContract: Array(12).fill(0),
  irrActualManual: Array(12).fill(0),
  acpActualManual: Array(12).fill(0),
  PRActualManual: Array(12).fill(0),
  availabilityManual: {
    data_down: Array(12).fill(0),
    t_useful: Array(12).fill(0),
    t_down: Array(12).fill(0)
  }
}];
export default {
  name: 'DataExcel',
  data: function data() {
    return {
      basicDeclineRate: 0.03,
      declineRate: 0.007,
      newDataLength: 1,
      monthArray: monthArray,
      pageList: pageList,
      uploadKpiFile: undefined,
      uploadKpiFileName: '',
      kpiSetting: clonedeep(defaultKpiSetting),
      kpiSettingByApi: [],
      kpiSettingManualList: [],
      // [true, false, true,... ]
      kpiSettingManualListByApi: [],
      // [true, false, true,... ]
      pdfArray: [],
      isEditing: false,
      tableData: [],
      tableHeader: [],
      csvName: '',
      resError: false,
      currentPage: pageList.mppt,
      isLoading: false
    };
  },
  computed: _objectSpread({}, mapState(['dataAdmin', 'userDetail'])),
  methods: {
    handleChangePage: function handleChangePage(currentPage) {
      this.isLoading = true;
      this.isEditing = false;
      this.currentPage = currentPage;
      switch (currentPage) {
        case pageList.mppt:
          this.tableData = [];
          this.tableHeader = [];
          this.csvName = '';
          this.getcsv('_串列資料.json');
          break;
        case pageList.pv:
          this.tableData = [];
          this.tableHeader = [];
          this.csvName = '';
          this.getcsv('_PVSYS.json');
          break;
        case pageList.pdf:
          this.pdfArray = [];
          this.getPdf();
          break;
        case pageList.kpi:
          // 清除上傳
          this.uploadKpiFile = undefined;
          this.uploadKpiFileName = '';
          this.kpiSetting = clonedeep(defaultKpiSetting);
          this.getKpiTable();
          break;
      }
      this.resError = false;
    },
    handleUpdateData: function handleUpdateData(currentPage) {
      if (currentPage === pageList.mppt || currentPage === pageList.pv) {
        this.updateCsv();
      }
      if (currentPage === pageList.kpi) {
        this.updateKpiSetting();
      }
    },
    handleUploadInputKpi: function handleUploadInputKpi(e) {
      var _e$target$files,
        _this = this;
      if (!((_e$target$files = e.target.files) !== null && _e$target$files !== void 0 && _e$target$files.length)) {
        this.uploadKpiFile = undefined; // 上傳後又取消，清除要上傳的暫存
        this.uploadKpiFileName = '';
        this.kpiSetting = _toConsumableArray(this.kpiSettingByApi);
        this.kpiSettingManualList = _toConsumableArray(this.kpiSettingManualListByApi);
        return;
      }
      var _e$target$files2 = _slicedToArray(e.target.files, 1),
        file = _e$target$files2[0];
      // check file name (file.name)
      var reader = new FileReader();

      // 讀取成 ArrayBuffer
      reader.readAsArrayBuffer(file);

      // 讀取成功
      reader.onloadend = function (e) {
        var _e$target;
        var data = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.result;
        var workbook = read(data, {
          type: 'array'
        });

        // year list
        var firstWorkSheet = workbook.Sheets['目標PR'];
        // 檢查 '!ref' 是否存在
        var firstSheetRef = firstWorkSheet['!ref'];
        if (!firstSheetRef) return _this.$swal('工作表範圍未定義');
        var columnA = [];
        var range = utils.decode_range(firstSheetRef); // 取得工作表的範圍
        for (var row = range.s.r; row <= range.e.r; row++) {
          // 遍歷所有行
          var cellAddress = "A".concat(row + 1); // 建立單元格地址，如 A1, A2, A3
          var cell = firstWorkSheet[cellAddress];
          // columnA.push(utils.format_cell(cell));
          columnA.push(cell === null || cell === void 0 ? void 0 : cell.v);
        }
        var yearList = columnA.filter(function (v) {
          return v && v !== '西元年別';
        }).map(function (v) {
          return String(v);
        });

        // deal with excel raw data
        var dataKeys = ['PR', 'properRate', 'peakWatt', 'guaranteePr', 'guaranteePower', 'acpGoalContract'];
        var dataKeyNames = ['目標PR', '妥善率', '峰瓩值', '保證PR', '保證發電量', '目標發電量'];
        var allProcessedJsonData = {};
        dataKeyNames.forEach(function (sheetName, idx) {
          var workSheet = workbook.Sheets[sheetName];
          var sheetJson = utils.sheet_to_json(workSheet);
          var processedJsonData = sheetJson.reduce(function (accu, curr) {
            var year = curr['西元年別'];
            accu[year] = monthArray.map(function (month) {
              return Math.round(curr[month] * 100) / 100 || 0;
            });
            return accu;
          }, {});
          allProcessedJsonData[dataKeys[idx]] = processedJsonData;
        });

        // final excel data
        var defaultData = Array(12).fill(0);
        var finalExcelData = yearList.map(function (year, _idx) {
          var _allProcessedJsonData, _allProcessedJsonData2, _allProcessedJsonData3, _allProcessedJsonData4, _allProcessedJsonData5, _allProcessedJsonData6;
          return {
            year: year,
            PR: (allProcessedJsonData === null || allProcessedJsonData === void 0 ? void 0 : (_allProcessedJsonData = allProcessedJsonData.PR) === null || _allProcessedJsonData === void 0 ? void 0 : _allProcessedJsonData[year]) || defaultData,
            properRate: (allProcessedJsonData === null || allProcessedJsonData === void 0 ? void 0 : (_allProcessedJsonData2 = allProcessedJsonData.properRate) === null || _allProcessedJsonData2 === void 0 ? void 0 : _allProcessedJsonData2[year]) || defaultData,
            peakWatt: (allProcessedJsonData === null || allProcessedJsonData === void 0 ? void 0 : (_allProcessedJsonData3 = allProcessedJsonData.peakWatt) === null || _allProcessedJsonData3 === void 0 ? void 0 : _allProcessedJsonData3[year]) || defaultData,
            guaranteePr: (allProcessedJsonData === null || allProcessedJsonData === void 0 ? void 0 : (_allProcessedJsonData4 = allProcessedJsonData.guaranteePr) === null || _allProcessedJsonData4 === void 0 ? void 0 : _allProcessedJsonData4[year]) || defaultData,
            guaranteePower: (allProcessedJsonData === null || allProcessedJsonData === void 0 ? void 0 : (_allProcessedJsonData5 = allProcessedJsonData.guaranteePower) === null || _allProcessedJsonData5 === void 0 ? void 0 : _allProcessedJsonData5[year]) || defaultData,
            acpGoalContract: (allProcessedJsonData === null || allProcessedJsonData === void 0 ? void 0 : (_allProcessedJsonData6 = allProcessedJsonData.acpGoalContract) === null || _allProcessedJsonData6 === void 0 ? void 0 : _allProcessedJsonData6[year]) || defaultData
          };
        });
        // console.log(finalExcelData)

        _this.uploadKpiFile = finalExcelData;
        _this.uploadKpiFileName = file.name;
        _this.setUploadExcelToKpiSetting(_this.uploadKpiFile);
      };

      // 讀取失敗
      reader.onerror = function (err) {
        return console.error('handleFileChange', err);
      };
    },
    setUploadExcelToKpiSetting: function setUploadExcelToKpiSetting(uploadedExcelData) {
      var _this2 = this;
      // 原本資料有啟用手動設定 Map
      var originalManualMap = new Map();
      this.kpiSetting.forEach(function (originObj, originIdx) {
        if (_this2.kpiSettingManualList[originIdx]) {
          return originalManualMap.set(originObj.year, originObj);
        }
      });
      this.kpiSetting = uploadedExcelData.map(function (obj, idx) {
        if (originalManualMap.has(obj.year)) {
          _this2.kpiSettingManualList[idx] = !!originalManualMap.has(obj.year);
          var copyObj = originalManualMap.get(obj.year);
          return _objectSpread(_objectSpread({}, copyObj), obj);
        }
        _this2.kpiSettingManualList[idx] = !!originalManualMap.has(obj.year);
        return _objectSpread(_objectSpread({}, obj), {}, {
          irrActualManual: Array(12).fill(0),
          acpActualManual: Array(12).fill(0),
          PRActualManual: Array(12).fill(0),
          availabilityManual: {
            data_down: Array(12).fill(0),
            t_useful: Array(12).fill(0),
            t_down: Array(12).fill(0)
          }
        });
      });
    },
    kpiSettingSplice: function kpiSettingSplice(idx) {
      this.kpiSetting.splice(idx, 1);
      this.kpiSettingManualList.splice(idx, 1);
    },
    kpiSettingNewData: function kpiSettingNewData() {
      var _this3 = this;
      if (this.kpiSetting[0].year.split('-')[1] === '預設值請修改') {
        return this.$swal('請先修改預設值');
      }

      // 新增幾年 -> 新增幾筆
      Array.from({
        length: this.newDataLength
      }).forEach(function () {
        var lastLength = _this3.kpiSetting.length - 1;
        var lastData = JSON.parse(JSON.stringify(_this3.kpiSetting[lastLength]));
        _this3.kpiSetting.push(_objectSpread(_objectSpread({}, lastData), {}, {
          irrActualManual: Array(12).fill(0),
          acpActualManual: Array(12).fill(0),
          PRActualManual: Array(12).fill(0),
          availabilityManual: {
            data_down: Array(12).fill(0),
            t_useful: Array(12).fill(0),
            t_down: Array(12).fill(0)
          }
        }));
        _this3.kpiSetting[_this3.kpiSetting.length - 1].year = "".concat(Number(_this3.kpiSetting[_this3.kpiSetting.length - 1].year) + 1);
        var diffYear = _this3.kpiSetting[_this3.kpiSetting.length - 1].year - _this3.kpiSetting[0].year;
        // PR 衰退
        // 第一年衰減 3%, 第二年(含)以後各年衰減 0.7%
        // 各年與初始值(第0年)相比的衰減幅度公式為 3%+(n-1)*0.7%, n 是第幾年
        var declinePr = JSON.parse(JSON.stringify(_this3.kpiSetting[0].PR));
        declinePr = declinePr.map(function (x) {
          return Math.round(x - (Number(_this3.basicDeclineRate) + (diffYear - 1) * Number(_this3.declineRate)) * x);
        });
        _this3.kpiSetting[_this3.kpiSetting.length - 1].PR = declinePr;
      });
    },
    updateKpiSetting: function updateKpiSetting() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _updateKpi$data;
        var updateKpiSettingData, updateKpi;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.kpiSetting[0].year.split('-')[1] === '預設值請修改')) {
                  _context.next = 3;
                  break;
                }
                _this4.$swal('請先修改預設值');
                return _context.abrupt("return");
              case 3:
                // check 上傳 manual 值
                updateKpiSettingData = _this4.kpiSetting.map(function (obj, idx) {
                  if (_this4.kpiSettingManualList[idx]) {
                    return obj;
                  } else {
                    var year = obj.year,
                      PR = obj.PR,
                      properRate = obj.properRate,
                      peakWatt = obj.peakWatt,
                      guaranteePr = obj.guaranteePr,
                      guaranteePower = obj.guaranteePower,
                      acpGoalContract = obj.acpGoalContract;
                    return {
                      year: year,
                      PR: PR,
                      properRate: properRate,
                      peakWatt: peakWatt,
                      guaranteePr: guaranteePr,
                      guaranteePower: guaranteePower,
                      acpGoalContract: acpGoalContract
                    };
                  }
                });
                _context.next = 6;
                return createKpiTableApi("".concat(_this4.$route.query.siteName, ".json"), updateKpiSettingData);
              case 6:
                updateKpi = _context.sent;
                if (updateKpi !== null && updateKpi !== void 0 && (_updateKpi$data = updateKpi.data) !== null && _updateKpi$data !== void 0 && _updateKpi$data.success) {
                  _this4.$swal('上傳成功');
                  _this4.getKpiTable();
                }
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getKpiTable: function getKpiTable() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _getKpi$data, getKpi;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getKpiTableApi("".concat(_this5.$route.query.siteName, ".json"));
              case 3:
                getKpi = _context2.sent;
                if (getKpi !== null && getKpi !== void 0 && (_getKpi$data = getKpi.data) !== null && _getKpi$data !== void 0 && _getKpi$data.success) {
                  _this5.kpiSetting = getKpi.data.data.map(function (obj, idx) {
                    var _obj$availabilityManu, _obj$availabilityManu2, _obj$availabilityManu3, _obj$availabilityManu4, _obj$availabilityManu5, _obj$availabilityManu6, _obj$availabilityManu7, _obj$availabilityManu8, _obj$availabilityManu9, _obj$availabilityManu10, _obj$availabilityManu11, _obj$availabilityManu12;
                    // 判斷 Manual 欄位
                    // 有一 Manual 即其餘全有
                    _this5.kpiSettingManualList[idx] = !!obj.acpActualManual;

                    // 有 data 但未滿 12 ---

                    var MONTHS_IN_YEAR = 12;
                    if (obj.irrActualManual && obj.irrActualManual.length !== MONTHS_IN_YEAR) {
                      var fillArrayLength = MONTHS_IN_YEAR - obj.irrActualManual.length;
                      Object.assign(obj, {
                        irrActualManual: [].concat(_toConsumableArray(obj.irrActualManual), _toConsumableArray(Array(fillArrayLength).fill(0)))
                      });
                    }
                    if (obj.acpActualManual && obj.acpActualManual.length !== MONTHS_IN_YEAR) {
                      var _fillArrayLength = MONTHS_IN_YEAR - obj.acpActualManual.length;
                      Object.assign(obj, {
                        acpActualManual: [].concat(_toConsumableArray(obj.acpActualManual), _toConsumableArray(Array(_fillArrayLength).fill(0)))
                      });
                    }
                    if (obj.PRActualManual && obj.PRActualManual.length !== MONTHS_IN_YEAR) {
                      var _fillArrayLength2 = MONTHS_IN_YEAR - obj.PRActualManual.length;
                      Object.assign(obj, {
                        PRActualManual: [].concat(_toConsumableArray(obj.PRActualManual), _toConsumableArray(Array(_fillArrayLength2).fill(0)))
                      });
                    }
                    if ((_obj$availabilityManu = obj.availabilityManual) !== null && _obj$availabilityManu !== void 0 && _obj$availabilityManu.data_down && ((_obj$availabilityManu2 = obj.availabilityManual) === null || _obj$availabilityManu2 === void 0 ? void 0 : (_obj$availabilityManu3 = _obj$availabilityManu2.data_down) === null || _obj$availabilityManu3 === void 0 ? void 0 : _obj$availabilityManu3.length) !== MONTHS_IN_YEAR) {
                      var _fillArrayLength3 = MONTHS_IN_YEAR - obj.availabilityManual.data_down.length;
                      Object.assign(obj, {
                        availabilityManual: _objectSpread(_objectSpread({}, obj.availabilityManual), {}, {
                          data_down: [].concat(_toConsumableArray(obj.availabilityManual.data_down), _toConsumableArray(Array(_fillArrayLength3).fill(0)))
                        })
                      });
                    }
                    if ((_obj$availabilityManu4 = obj.availabilityManual) !== null && _obj$availabilityManu4 !== void 0 && _obj$availabilityManu4.t_useful && ((_obj$availabilityManu5 = obj.availabilityManual) === null || _obj$availabilityManu5 === void 0 ? void 0 : (_obj$availabilityManu6 = _obj$availabilityManu5.t_useful) === null || _obj$availabilityManu6 === void 0 ? void 0 : _obj$availabilityManu6.length) !== MONTHS_IN_YEAR) {
                      var _fillArrayLength4 = MONTHS_IN_YEAR - obj.availabilityManual.t_useful.length;
                      Object.assign(obj, {
                        availabilityManual: _objectSpread(_objectSpread({}, obj.availabilityManual), {}, {
                          t_useful: [].concat(_toConsumableArray(obj.availabilityManual.t_useful), _toConsumableArray(Array(_fillArrayLength4).fill(0)))
                        })
                      });
                    }
                    if ((_obj$availabilityManu7 = obj.availabilityManual) !== null && _obj$availabilityManu7 !== void 0 && _obj$availabilityManu7.t_down && ((_obj$availabilityManu8 = obj.availabilityManual) === null || _obj$availabilityManu8 === void 0 ? void 0 : (_obj$availabilityManu9 = _obj$availabilityManu8.t_down) === null || _obj$availabilityManu9 === void 0 ? void 0 : _obj$availabilityManu9.length) !== MONTHS_IN_YEAR) {
                      var _fillArrayLength5 = MONTHS_IN_YEAR - obj.availabilityManual.t_down.length;
                      Object.assign(obj, {
                        availabilityManual: _objectSpread(_objectSpread({}, obj.availabilityManual), {}, {
                          t_down: [].concat(_toConsumableArray(obj.availabilityManual.t_down), _toConsumableArray(Array(_fillArrayLength5).fill(0)))
                        })
                      });
                    }

                    // 無 data ---

                    if (!obj.guaranteePr) {
                      Object.assign(obj, {
                        guaranteePr: Array(12).fill(0)
                      });
                    }
                    if (!obj.guaranteePower) {
                      Object.assign(obj, {
                        guaranteePower: Array(12).fill(0)
                      });
                    }
                    if (!obj.acpGoalContract) {
                      Object.assign(obj, {
                        acpGoalContract: Array(12).fill(0)
                      });
                    }
                    if (!obj.irrActualManual) {
                      Object.assign(obj, {
                        irrActualManual: Array(12).fill(0)
                      });
                    }
                    if (!obj.acpActualManual) {
                      Object.assign(obj, {
                        acpActualManual: Array(12).fill(0)
                      });
                    }
                    if (!obj.PRActualManual) {
                      Object.assign(obj, {
                        PRActualManual: Array(12).fill(0)
                      });
                    }
                    if (!((_obj$availabilityManu10 = obj.availabilityManual) !== null && _obj$availabilityManu10 !== void 0 && _obj$availabilityManu10.data_down)) {
                      Object.assign(obj, {
                        availabilityManual: _objectSpread(_objectSpread({}, obj.availabilityManual), {}, {
                          data_down: Array(12).fill(0)
                        })
                      });
                    }
                    if (!((_obj$availabilityManu11 = obj.availabilityManual) !== null && _obj$availabilityManu11 !== void 0 && _obj$availabilityManu11.t_useful)) {
                      Object.assign(obj, {
                        availabilityManual: _objectSpread(_objectSpread({}, obj.availabilityManual), {}, {
                          t_useful: Array(12).fill(0)
                        })
                      });
                    }
                    if (!((_obj$availabilityManu12 = obj.availabilityManual) !== null && _obj$availabilityManu12 !== void 0 && _obj$availabilityManu12.t_down)) {
                      Object.assign(obj, {
                        availabilityManual: _objectSpread(_objectSpread({}, obj.availabilityManual), {}, {
                          t_down: Array(12).fill(0)
                        })
                      });
                    }
                    return obj;
                  });
                }
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log('getKpi error', _context2.t0);
              case 10:
                _context2.prev = 10;
                // 另存 api 的資料 (api 有存 api 的，沒有存 this.kpiSetting)
                _this5.kpiSettingByApi = _toConsumableArray(_this5.kpiSetting);
                _this5.kpiSettingManualListByApi = _toConsumableArray(_this5.kpiSettingManualList);
                _this5.isLoading = false;
                return _context2.finish(10);
              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7, 10, 15]]);
      }))();
    },
    changeTableTitle: function changeTableTitle(s, idx, i) {
      var name = i;
      this.tableHeader[idx] = s;
      this.tableData.forEach(function (x) {
        Object.defineProperty(x, s, Object.getOwnPropertyDescriptor(x, name));
        delete x[name];
      });
    },
    getPdf: function getPdf() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _pdf$data;
        var pdf, arr;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getPdfApi(_this6.$route.query.fid);
              case 2:
                pdf = _context3.sent;
                if (pdf !== null && pdf !== void 0 && (_pdf$data = pdf.data) !== null && _pdf$data !== void 0 && _pdf$data.success) {
                  arr = [];
                  pdf.data.data.forEach(function (x) {
                    var nameSplit = x.split('/');
                    arr.push({
                      name: nameSplit[nameSplit.length - 1],
                      value: x
                    });
                  });
                  _this6.pdfArray = arr;
                  if (!_this6.pdfArray.length) _this6.resError = true;
                }
                _this6.isLoading = false;
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getcsv: function getcsv(str) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var fileName, _csv$data, csv;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fileName = _this7.$route.query.siteName + str;
                _context4.prev = 1;
                _context4.next = 4;
                return getCsvApi(fileName);
              case 4:
                csv = _context4.sent;
                if (csv !== null && csv !== void 0 && (_csv$data = csv.data) !== null && _csv$data !== void 0 && _csv$data.success) {
                  _this7.csvName = csv.data.data.fileName;
                  _this7.tableData = csv.data.data.csvData;
                  _this7.tableHeader = csv.data.data.csvHeader;
                } else {
                  _this7.resError = true;
                }
                _context4.next = 12;
                break;
              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                console.log('getCsv error', _context4.t0);
                _this7.resError = true;
              case 12:
                _context4.prev = 12;
                _this7.isLoading = false;
                return _context4.finish(12);
              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 8, 12, 15]]);
      }))();
    },
    updateCsv: function updateCsv() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _update$data;
        var csvHeader, csvData, update;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                csvHeader = _this8.tableHeader;
                csvData = _this8.tableData;
                _context5.next = 4;
                return updateCsvApi(_this8.csvName, csvHeader, csvData);
              case 4:
                update = _context5.sent;
                if (update !== null && update !== void 0 && (_update$data = update.data) !== null && _update$data !== void 0 && _update$data.success) {
                  _this8.$swal('儲存成功');
                }
              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    checkDeletePdf: function checkDeletePdf(pdfName) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.$swal.fire({
                  title: "\u78BA\u5B9A\u8981\u522A\u9664?",
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "\u78BA\u5B9A",
                  denyButtonText: "\u5426"
                }).then(function (result) {
                  if (result.isConfirmed) {
                    _this9.deletePdf(pdfName);
                  }
                });
              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    deletePdf: function deletePdf(pdfName) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _deletePdf$data;
        var deletePdf;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return deletePdfApi(_this10.$route.query.siteName, pdfName);
              case 2:
                deletePdf = _context7.sent;
                if (deletePdf !== null && deletePdf !== void 0 && (_deletePdf$data = deletePdf.data) !== null && _deletePdf$data !== void 0 && _deletePdf$data.success) {
                  _this10.$swal('刪除成功');
                  _this10.getPdf();
                }
              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  created: function created() {
    this.getcsv('_串列資料.json');
  }
};